import { getTableIntentLink } from "@components/drillDown/DrillDown.utils";
import { IFieldInfoProperties } from "@components/smart/FieldInfo";
import { TCellValue } from "@components/table";
import { IFormatOptions } from "@odata/OData.utils";

import { Sort } from "../../../enums";
import { TValue } from "../../../global.types";
import { ROUTE_EMPLOYEES, ROUTE_PAYSLIP } from "../../../routes";

export function getEmployeeNumberOursCommonDef(): IFieldInfoProperties {
    return {
        formatter: (val: TValue, args: IFormatOptions): TCellValue => {
            if (!val) {
                return null;
            }
            const employeeId = args.entity["PrEmployee_Id"];
            if (!employeeId) {
                return val.toString();
            }
            const url = `${ROUTE_EMPLOYEES}/${employeeId}`;
            return getTableIntentLink(val.toString(), {
                route: url,
                context: args.storage.context,
                storage: args.storage
            });
        }
    };
}

export function getPayslipCommonDef(): IFieldInfoProperties {
    return {
        formatter: (val: TValue, args: IFormatOptions): TCellValue => {
            if (!val) {
                return null;
            }
            const payslipId = args.entity["PrPayslip_Id"];
            if (!payslipId) {
                return val.toString();
            }
            const url = `${ROUTE_PAYSLIP}/${payslipId}`;
            return getTableIntentLink(val.toString(), {
                route: url,
                context: args.storage.context,
                storage: args.storage
            });
        }
    };
}

export const payslipInitialSortBy = [{ id: "YearMonth", sort: Sort.Desc }, { id: "Name", sort: Sort.Asc }];